import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import { SITE } from "@/data/site";

const Row = ({ label, children }) => (
  <div className="border-t border-white/10 py-4 sm:grid sm:grid-cols-[220px_1fr] sm:gap-6">
    <p className="font-body text-xs font-bold uppercase tracking-[0.15em] text-volt">{label}</p>
    <p className="mt-1 font-body text-neutral-300 sm:mt-0">{children}</p>
  </div>
);

export default function Impressum() {
  return (
    <Layout>
      <Seo title="Impressum | KeyMaster KFZ Cloppenburg" description="Impressum und Anbieterkennzeichnung von KeyMaster KFZ, Cloppenburg." path="/impressum" />
      <section className="bg-[#050505] pt-32 pb-24 sm:pt-40">
        <div className="mx-auto max-w-[900px] px-5 sm:px-8">
          <h1 className="font-heading text-5xl font-black uppercase tracking-tight text-white sm:text-6xl">Impressum</h1>
          <p className="mt-4 font-body text-neutral-400">Angaben gemäß § 5 TMG / § 18 Abs. 2 MStV</p>

          <div className="mt-10">
            <Row label="Anbieter">{SITE.owner}</Row>
            <Row label="Anschrift">{SITE.address.street}, {SITE.address.zip} {SITE.address.city}</Row>
            <Row label="Vertreten durch">{SITE.owner}</Row>
            <Row label="Telefon"><a href={`tel:${SITE.phoneIntl}`} className="hover:text-volt">{SITE.phoneDisplay}</a></Row>
            <Row label="E-Mail"><a href={`mailto:${SITE.email}`} className="hover:text-volt">{SITE.email}</a></Row>
            <Row label="Umsatzsteuer-ID">{SITE.ustId}</Row>
            <Row label="Inhaltlich verantwortlich">{SITE.owner}, {SITE.address.street}, {SITE.address.zip} {SITE.address.city}</Row>
          </div>

          <div className="mt-12 space-y-6 font-body text-sm leading-relaxed text-neutral-400">
            <div>
              <h2 className="mb-2 font-heading text-xl font-bold uppercase text-white">Umsatzsteuer</h2>
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 19 Umsatzsteuergesetz (UStG).</p>
            </div>
            <div>
              <h2 className="mb-2 font-heading text-xl font-bold uppercase text-white">Haftung für Inhalte</h2>
              <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.</p>
            </div>
            <div>
              <h2 className="mb-2 font-heading text-xl font-bold uppercase text-white">Haftung für Links</h2>
              <p>Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.</p>
            </div>
            <div>
              <h2 className="mb-2 font-heading text-xl font-bold uppercase text-white">Urheberrecht</h2>
              <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
